// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/conti-analitici?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, natura, attivo, livello, divisioneId, figli }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/budget-conto-analitico?societaId=&anno=',
    requestBody: null,
    response: '{ success: true, data: [{ contoAnaliticoId, importo }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/divisioni-analitiche?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, attivo }] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/budget-conto-analitico',
    requestBody: '{ societaId, anno, voci: [{ contoAnaliticoId, importo }] }',
    response: '{ success: true, data: [{ contoAnaliticoId, importo }] }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
